var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6772 0H5.15495C3.94259 0 2.77989 0.481609 1.92262 1.33888C1.06535 2.19615 0.58374 3.35885 0.58374 4.57121L0.58374 38.0935C0.58374 39.3058 1.06535 40.4685 1.92262 41.3258C2.77989 42.1831 3.94259 42.6647 5.15495 42.6647H18.2258V28.1596H12.2261V21.3323H18.2258V16.1288C18.2258 10.21 21.7494 6.94063 27.1463 6.94063C29.7309 6.94063 32.4337 7.40156 32.4337 7.40156V13.2108H29.4557C26.5216 13.2108 25.6064 15.0317 25.6064 16.8992V21.3323H32.1565L31.109 28.1596H25.6064V42.6647H38.6772C39.8896 42.6647 41.0523 42.1831 41.9095 41.3258C42.7668 40.4685 43.2484 39.3058 43.2484 38.0935V4.57121C43.2484 3.35885 42.7668 2.19615 41.9095 1.33888C41.0523 0.481609 39.8896 0 38.6772 0Z",
    fill: "url(#paint0_linear_203_4009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_4009",
    x1: 0.58374,
    y1: 42.6647,
    x2: 43.2484,
    y2: 42.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5773FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e380770514d8309f74bdd8b4106020e7.svg";
export { ForwardRef as ReactComponent };